
import { Card, Table } from "antd";
import AppLayout from "../../components/Layout";
import { downloadEmailEventsExcel, getBulkEmailReport } from "../../services/commonController";
import { useQuery } from "@tanstack/react-query";
import { FileExcelOutlined } from "@ant-design/icons";
interface BulkEmailReport {
  sentDate: string;
  templateName: string;
  totalSent: number;
  totalOpens: number;
  totalClicks: number;
  openRate: number;
  clickRate: number;
}

const BulkEmail = () => {

  const { data: bulkEmailReport } = useQuery<BulkEmailReport[]>({
    queryKey: ["bulkEmailReport"],
    queryFn: getBulkEmailReport,
  });

const handleExport = async (sentDate: string) => {
  try {
    const response = await downloadEmailEventsExcel(
      sentDate,
      sentDate,
      "all"
    );

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `email-events-${sentDate}.xlsx`;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Excel download failed", error);
  }
};

  const bulkEmailColumns = [
    {
      title: "Sent Date",
      dataIndex: "sentDate",
      key: "sentDate",
      render: (date: string) => {
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "Template Name",
      dataIndex: "templateName",
      key: "templateName",
    },
    {
      title: "Total Sent",
      dataIndex: "totalSent",
      key: "totalSent",
      align: "center" as const,
    },
    {
      title: "Total Opens",
      dataIndex: "totalOpens",
      key: "totalOpens",
      align: "center" as const,
    },
    {
      title: "Open Rate",
      dataIndex: "openRate",
      key: "openRate",
      render: (value: number) => `${value.toFixed(2)}%`,
      align: "center" as const,
    },
    {
      title: "Total Clicks",
      dataIndex: "totalClicks",
      key: "totalClicks",
      align: "center" as const,
    },
    {
      title: "Click Rate",
      dataIndex: "clickRate",
      key: "clickRate",
      render: (value: number) => `${value.toFixed(2)}%`,
      align: "center" as const,
    },
   {
  title: "",
  key: "export",
  width: 60,
  align: "center" as const,
  render: (_:any, record:any) => (
    <FileExcelOutlined
      style={{
        fontSize: 18,
        color: "#52c41a",
        cursor: "pointer",
      }}
      onClick={() => handleExport(record.sentDate)}
    />
  ),
}
  ];


  return (
    <AppLayout  moduleName="Email Analytics" >
      <div>
        <Card title="Email Performance Report">
          <Table<BulkEmailReport>
            columns={bulkEmailColumns}
            dataSource={bulkEmailReport || []}
             pagination={{
                 position: ["bottomCenter"],
                 }}
          />
        </Card>
      </div>
    </AppLayout>
  );
};

export default BulkEmail;
